/* unplugin-vue-components disabled */import { render } from "./PersonalInformation.vue?vue&type=template&id=7cd0b449&scoped=true"
import script from "./PersonalInformation.vue?vue&type=script&lang=js"
export * from "./PersonalInformation.vue?vue&type=script&lang=js"

import "./PersonalInformation.vue?vue&type=style&index=0&id=7cd0b449&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cd0b449"]])

export default __exports__